import { reduxForm } from 'redux-form';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import { FORM_NAMES } from 'constants/forms';
import validate from './validate';
import ChangePassword from './ChangePassword';

export default compose(
  reduxForm({
    form: FORM_NAMES.changePassword,
    validate,
  }),
  withTranslation(),
)(ChangePassword);
